import axios from 'axios';

export default axios.create({
  baseURL: process.env.REACT_APP_INSTAGRAM_API_URL,
  headers: {
    Accept: 'application/json'
  }
});
